export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'MMMM DD, YYYY @ hh:MM A';
export const DATE_ORDER_FORMAT = 'MMMM Do YYYY';

export const DATE_SEPARATE_YEAR_FORMAT = 'MMM DD, YYYY';
export const DATE_ORDER_SEPARATE_YEAR_FORMAT = 'MMMM Do, YYYY';
export const DATE_SHORT_SEPARATE_YEAR_FORMAT = 'MMMM D, YYYY';

export const WEEKDAY_FORMAT = 'dddd, MMMM DD, YYYY';
export const SHORT_WEEKDAY_FORMAT = 'dddd, MMMM D';

export const DATE_MONTH_FORMAT = 'MMMM-DD';
